import React, {forwardRef} from "react";

import Input from "../../1_elements/Input";

/* Props
*  label        : string
*  inputId      : string, to identify input and link it to its label
*  placeholder  : string
*  type         : string, can be integer / string to apply validation controls
*  isReadOnly   : bool, set to true if input shouldn't be modified
*/
const InputText = forwardRef( function InputText({
    ...props
}, ref) {
    /** 
     * Control errors based on the type of input
     */
    function controlErrors(value) {
        const error = (props.isRequired && (!value || value?.toString().trim().length === 0));
        return ({error: error, message: "Ce champ est obligatoire"});
    }

    const error = {controlErrors: controlErrors};

    return (
        <Input
            ref={ref}            
            {...props}
            error={error}
            type="text"
        />
    )
})

export default InputText;